import { Routes, Route } from 'react-router-dom'
import Layout from '@/components/layout/Layout'
import HomePage from '@/pages/HomePage'
import PredicationsPage from '@/pages/PredicationsPage'
import PredicationDetailPage from '@/pages/PredicationDetailPage'
import PremiereVisitePage from '@/pages/PremiereVisitePage'
import AProposPage from '@/pages/AProposPage'
import ContactPage from '@/pages/ContactPage'

export default function App() {
  return (
    <Routes>
      <Route element={<Layout />}>
        <Route index element={<HomePage />} />
        <Route path="predications" element={<PredicationsPage />} />
        <Route path="predications/:id" element={<PredicationDetailPage />} />
        <Route path="premiere-visite" element={<PremiereVisitePage />} />
        <Route path="a-propos" element={<AProposPage />} />
        <Route path="contact" element={<ContactPage />} />
      </Route>
    </Routes>
  )
}
